import { useState } from 'react';

import { loadPoliticalMatchUserPhoto, savePoliticalMatchUserPhoto } from '@/services/political-match-user-photo-storage';

export function usePoliticalMatchUserPhoto(): {
  userPhotoUrl: string | null;
  setUserPhotoUrl: (photoUrl: string | null) => void;
} {
  const [userPhotoUrl, setUserPhotoUrlState] = useState<string | null>(() => loadPoliticalMatchUserPhoto());

  const setUserPhotoUrl = (photoUrl: string | null): void => {
    setUserPhotoUrlState(photoUrl);
    savePoliticalMatchUserPhoto(photoUrl);
  };

  return { userPhotoUrl, setUserPhotoUrl };
}
